import { StringUtils } from './../../services/utils/string.utils';

export class DependencyItemObject {
    private _name: string;
    private _activation: string;


    constructor(name: string, activation: string) {
        this._name = name;
        this._activation = activation;
    }

    public create(): DependencyItemObject {
        return new DependencyItemObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE);
    }


    public get name(): string {
        return this._name;
    }

    public get activation(): string {
        return this._activation;
    }

}
